import { renderCurrencyChar } from "./renderCurrencyChar";

/**
 * Convert balance to integer value with maximum 4 decimal places.
 * When a currency code is provided, the appropriate currency symbol is prepended.
 *
 * @param amount
 * @param showPlaceholder
 * @param currency - optional ISO currency code (e.g. "usd", "aud")
 * @returns
 */
export const convertBalance = (
  amount?: number,
  showPlaceholder: boolean = true,
  currency?: string
): string => {
  const currencyChar = renderCurrencyChar(currency);

  if (showPlaceholder && amount === 0) return currencyChar + "--";
  if (amount == null) return "";

  let balanceAmount = (amount / 10000).toString();

  if (balanceAmount.includes(".")) {
    // decimal case (shows just 2 decimal place)
    const integerPart = balanceAmount.split(".")[0];
    let decimalPart = balanceAmount.split(".")[1];

    decimalPart = decimalPart.substring(0, 2);
    if (decimalPart.length === 1) {
      decimalPart = decimalPart.concat("0");
    }
    balanceAmount = integerPart + "." + decimalPart;
  } else {
    // integer case
    balanceAmount = balanceAmount.concat(".00");
  }
  return currencyChar + balanceAmount;
};
